
const font = {
  family: '"Kanit", sans-serif;',
  color: {
    default: '#000',
    light: '#686868',
    dark: '#0a0101',
    inverse: '#fff'
  },
  size: {
    default: '1em',
    small: '0.8em',
    xs: '0.65em',
    mainTitle: '1.5em',
    title: '1.25em',
    subTitle: '1.15em',
    panelTitle: '22px',
    bottomMenu: '0.75em',
    credit: '1.7rem'
  },
  weight: {
    light: '200',
    normal: '300',
    bold: '400',
    button: '400'
  }
};

const gutter = {
  default: '1rem',
  xs: '0.25rem',
  small: '0.5rem',
  medium: '0.75rem',
  large: '1.5rem',
  table: '.75rem',
  section: '4rem'
};

const colors = {
  primary: {
    default: '#ddad50',
    dark: '#9c0405',
    light: '#f9dddc'
  },
  second: {
    default: '#011062',
    light: '#ffb547'
  },
  success: {
    default: '#4CAF50',
    light: '#66cc99'
  },
  info: {
    default: '#22a7f0'
  },
  danger: {
    default: '#E74C3C'
  },
  warning: {
    default: '#f7be38'
  },
  white: '#ffffff',
  border: {
    default: '#686868'
  },
  gray: {
    light: '#f5f5f5',
    dark: '#d6d8d9'
  },
  drop: '#eadbdd',
  panel: '#fff',
  background: {
    default: '#dfdfdf',
    light: '#f6e6e6',
    highlight: '#ad0e0e',
    input: '#fff',
    navbar: '#fff',
    page: '#fff'
  }
};

const link = {
  color: '#001687',
  decoration: 'underline'
};

const borderRadius = {
  default: '4px',
  large: '10px'
};
const borderColor = '#ddd';
const borderStyle = '1px solid';
const border = {
  default: `${borderStyle} ${borderColor}`,
  primary: `${borderStyle} ${colors.primary.light}`,
  success: `${borderStyle} ${colors.success.default}`,
  input: `${borderStyle} ${colors.primary.default}`,
  disabled: `${borderStyle} #eee`,
  info: `${borderStyle} ${colors.info.default}`
};

const screen = {
  xxs: {
    max: '349.98px'
  },
  xs: {
    max: '575.98px'
  },
  sm: {
    up: '576px',
    max: '767.98px'
  },
  md: {
    up: '768px',
    max: '991.98px'
  },
  lg: {
    up: '992px',
    max: '1199.98px'
  },
  xl: {
    up: '1200px',
    max: '1399.98px'
  },
  hd: {
    up: '1400px'
  }
};

const container = {
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  default: '820px',
  wallet: '470px'
};

const contentGutter = '2rem';
const headerPadding = '15px 30px';
const delay = 'all 0.3s ease-in-out';

const zindex = {
  default: '1024',
  navbar: '2048',
  bottomNav: '2148',
  sportNavbar: '1124',
  modal: '2248',
  menu: '2100',
  quickMenu: '2150'
};


const initialBackground = '#eff2f7';

export {
  font,
  gutter,
  colors,
  link,
  border,
  borderRadius,
  borderColor,
  contentGutter,
  headerPadding,
  screen,
  delay,
  container,
  zindex,
  initialBackground
};
